module.exports = __webpack_public_path__ + "static/media/broker-landing-ui.fa2ba480.webp";